import { createStateContext } from 'react-use';

export interface IContactForm {
    firstName: string;
    lastName: string;
    email: string;
    company: string;
    message: string;
}

export const [useContentContext, ContentContext] = createStateContext(<IContactForm>{
    firstName: '',
    lastName: '',
    company: '',
    message: '',
    email: '',
});
